var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:Material Icons;font-style:normal;font-weight:400;src:url(" + escape(require("./MaterialIcons-Regular.eot")) + ");src:local(\"Material Icons\"),local(\"MaterialIcons-Regular\"),url(" + escape(require("./MaterialIcons-Regular.woff2")) + ") format(\"woff2\"),url(" + escape(require("./MaterialIcons-Regular.woff")) + ") format(\"woff\"),url(" + escape(require("./MaterialIcons-Regular.ttf")) + ") format(\"truetype\")}.material-icons{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;font-feature-settings:\"liga\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/assets/css/material-icons/material-icons.css
// module id = 361
// module chunks = 134